export const ADD_LOGIN_INPUT = "ADD_LOGIN_INPUT"
export const REMOVE_LOGIN_INPUT = "REMOVE_LOGIN_INPUT"
export const REMOVE_ALL_LOGIN_INPUTS = "REMOVE_ALL_LOGIN_INPUTS"
export const LOGIN = "LOGIN"
export const GRAPHQL_REQUEST_ACCESS_TOKEN = "GRAPHQL_REQUEST_ACCESS_TOKEN"
export const GRAPHQL_REQUEST_GET_COMPANY_ID = "GRAPHQL_REQUEST_GET_COMPANY_ID"